import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import { formatDate } from '../../../config/appConfig';
import { useMgaPeriods, type MgaPeriod } from '../../mga/useData';
import GenericListWidget from './GenericListWidget';

const MgaRecentPeriods: React.FC<{
  limit?: number;
  embedded?: boolean;
  settings?: Record<string, unknown>;
}> = ({ limit = 5, embedded, settings }) => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const effectiveLimit = typeof settings?.limit === 'number' ? settings.limit : limit;
  const { data, isLoading } = useMgaPeriods(undefined, 1, 50);

  const items = [...(data ?? [])]
    .sort(
      (a, b) =>
        new Date(b.updatedAt || b.createdAt).getTime() - new Date(a.updatedAt || a.createdAt).getTime(),
    )
    .slice(0, effectiveLimit);

  return (
    <GenericListWidget<MgaPeriod>
      title="MGA · Recent periods"
      viewAllPath="/mga"
      data={items}
      isLoading={isLoading}
      limit={effectiveLimit}
      emptyMessage="No periods"
      getItemKey={(p) => p.id}
      embedded={embedded}
      renderItem={(period) => (
        <div
          onClick={() => navigate(`/mga/${period.id}`)}
          className="flex items-center justify-between gap-3 p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/40 cursor-pointer"
        >
          <div className="min-w-0">
            <p className={`text-sm font-medium truncate ${colors.text}`}>
              {period.vessel?.vesselName || `Vessel #${period.vesselId}`}
            </p>
            <p className={`text-xs ${colors.textMuted}`}>
              {formatDate(period.periodFrom)}–{formatDate(period.periodTo)} · {period.status}
            </p>
          </div>
          <span className={`text-xs whitespace-nowrap ${colors.textMuted}`}>
            {formatDate(period.updatedAt || period.createdAt)}
          </span>
        </div>
      )}
    />
  );
};

export default MgaRecentPeriods;
